module.exports = __webpack_public_path__ + "prod/20260915122951/img/service.edbff227.png";